<template>
  <a-gradient-border class="homepage-key-statistics-main-block__wrapper">
    <div class="homepage-key-statistics-main-block__container">
      <div class="homepage-key-statistics-main-block__logo">
        <a-image
          :aspect-ratio="$options.consts.ASPECT_RATIO.KEY_STATISTICS_CIRCLE"
          :src="$options.consts.KEY_STATISTICS_CIRCLE_SRC"
          alt="Graphic showing '15M monthly requests' with 'ForexLive RSS Feed Requests' below in a blue circular design."
        />
      </div>

      <ul class="homepage-key-statistics-main-block__items">
        <li
          v-for="item in items"
          :key="item.description"
          class="homepage-key-statistics-main-block__item"
        >
          <div class="homepage-key-statistics-main-block__item-title">
            {{ item.title }}
          </div>
          <div class="homepage-key-statistics-main-block__item-description">
            {{ item.description }}
          </div>
        </li>
      </ul>
    </div>
  </a-gradient-border>
</template>

<script>
import AGradientBorder from 'shared/AGradientBorder/index.vue'
import { ASPECT_RATIO } from 'enums/aspectRatios'

export default {
  name: 'HomepageKeyStatisticsMainBlock',
  components: { AGradientBorder },
  consts: {
    ASPECT_RATIO,
    KEY_STATISTICS_CIRCLE_SRC: '/images/key-statistics-circle.svg'
  },
  data() {
    return {
      items: [
        {
          title: '6M',
          description: 'General'
        },
        {
          title: '4M',
          description: 'News'
        },
        {
          title: '1.5M',
          description: 'Technical Analysis'
        },
        {
          title: '1M',
          description: 'Central Bank'
        },
        {
          title: '1M',
          description: 'Forex Orders'
        },
        {
          title: '1M',
          description: 'Cryptocurrency'
        },
        {
          title: '500k',
          description: 'Education'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~assets/scss/local/mixins/grid';

.homepage-key-statistics-main-block__wrapper {
  $margin: (
    $desktop-lg: 0 -8px,
    $mobile: 0 -#{$padding-x-mobile}
  );

  $border-radius: (
    $above-desktop-xl: 16px,
    $mobile: 0
  );

  $padding: (
    $above-desktop-xl: 2px,
    $mobile: 2px 0
  );

  @include setStyleByBreakpoint('padding', $padding);
  @include setStyleByBreakpoint('border-radius', $border-radius);
  @include setStyleByBreakpoint('margin', $margin);

  .homepage-key-statistics-main-block__container {
    background: $c--gray-dark;

    $grid-setup: (
      $columnSetup: (
        $above-desktop-xl: 492px auto,
        $desktop-sm: auto
      ),
      $columnGapSetup: (
        $above-desktop-xl: 64px
      )
    );

    align-items: center;

    @include gridBuilder($grid-setup);

    $padding: (
      $above-desktop-xl: 64px,
      $desktop-lg: 64px 32px,
      $mobile: 32px 24px
    );

    @include setStyleByBreakpoint('padding', $padding);
  }

  .homepage-key-statistics-main-block__logo {
    $width: (
      $above-desktop-xl: 492px,
      $mobile: 272px
    );

    $height: (
      $above-desktop-xl: 500px,
      $mobile: 276px
    );

    $margin: (
      $desktop-sm: 0 auto 64px
    );

    @include setStyleByBreakpoint('margin', $margin);
    @include setStyleByBreakpoint('height', $height);
    @include setStyleByBreakpoint('width', $width);
  }

  .homepage-key-statistics-main-block__items {
    $grid-setup: (
      $columnSetup: (
        $above-desktop-xl: repeat(3, 166px),
        $desktop-md: repeat(2, 166px),
        $desktop-sm: repeat(3, 166px),
        $mobile: repeat(2, 1fr)
      ),
      $columnGapSetup: (
        $above-desktop-xl: 32px
      ),
      $rowGapSetup: (
        $above-desktop-xl: 32px
      )
    );

    grid-auto-rows: min-content;

    @include gridBuilder($grid-setup);

    $justify-content: (
      $desktop-sm: center
    );

    @include setStyleByBreakpoint('justify-content', $justify-content);
  }

  .homepage-key-statistics-main-block__item {
    display: flex;
    flex-direction: column;

    &:nth-last-child(2) {
      @include mobile {
        grid-row: 4;
        grid-column: span 2;
      }
    }

    &:last-child {
      $grid-column: (
        $desktop-sm: 2
      );

      @include setStyleByBreakpoint('grid-column', $grid-column);

      @include mobile {
        grid-row: 3;
      }
    }
  }

  .homepage-key-statistics-main-block__item-title {
    color: $c--link;
    font-weight: 600;

    $font-size: (
      $above-desktop-xl: 48px,
      $mobile: 30px
    );

    $line-height: (
      $above-desktop-xl: 70px,
      $mobile: 38px
    );

    @include setStyleByBreakpoint('font-size', $font-size);
    @include setStyleByBreakpoint('line-height', $line-height);
  }

  .homepage-key-statistics-main-block__item-description {
    color: $c--blue-secondary;

    $font-size: (
      $above-desktop-xl: 20px,
      $mobile: 18px
    );

    $line-height: (
      $above-desktop-xl: 30px,
      $mobile: 28px
    );

    @include setStyleByBreakpoint('font-size', $font-size);
    @include setStyleByBreakpoint('line-height', $line-height);
  }
}
</style>
